import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI }                     from 'ng-block-ui';
import { DomSanitizer, SafeResourceUrl }          from '@angular/platform-browser';

import { EditorTokenModel }   from './typings/workshop-web.editor-token';
import { MessagesService }    from '../messages/messages.service';
import { WorkshopWebService } from './workshop-web.service';

@Component({
  selector   : 'wor-workshop-web-frame',
  template: require('./workshop-web.frame.component.html')
})
export class WorkshopWebFrameComponent implements OnInit {
  @BlockUI('workshopWebFrameBlock') block : NgBlockUI;

  @Input() set url ( _url: string ) {
    this._url = this.sanitizer.bypassSecurityTrustResourceUrl(_url);
  };

  _url  : SafeResourceUrl | null = null;

  constructor (
    private messagesService   : MessagesService,
    private sanitizer         : DomSanitizer,
    private workshopWebService: WorkshopWebService
  ) {}

  @HostListener( 'window:message', [ '$event' ] )
  onMessage ( event : MessageEvent ) : void {
    if ( this.workshopWebService.isEnrichmentDone(event) ) {
      this.loadEditorToken();
    }
  }

  ngOnInit () : void {
    this.loadEditorToken();
  }

  loadEditorToken () : void {
    this.block.start();

    this.workshopWebService.getEditorToken()
    .then(( token : EditorTokenModel ) => {
      this.url = token.editor_url;
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.block.stop());
  }

  viewSite () : void {
    window.open(this.url);
  }
}
